import React from "react";
import MasonryGallery from "../components/MasonryGallery";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const CustomCursor = () => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            if (e.target.closest("button, a, .cursor-hover")) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseover", handleMouseOver);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);

    return (
        <div
            className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            <div
                className={`rounded-full bg-white transition-all duration-300 ease-out ${
                    isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
                }`}
            />
        </div>
    );
};

const ChrisMedhaGallery = () => {
    const images = [
        "/assets/wedding/chris_medha_webp/w1.webp",
        "/assets/wedding/chris_medha_webp/w2.webp",
        "/assets/wedding/chris_medha_webp/w3.webp",
        "/assets/wedding/chris_medha_webp/w4.webp",
        "/assets/wedding/chris_medha_webp/w5.webp",
        "/assets/wedding/chris_medha_webp/w6.webp",
        "/assets/wedding/chris_medha_webp/w7.webp",
        "/assets/wedding/chris_medha_webp/w8.webp",
        "/assets/wedding/chris_medha_webp/w9.webp",
        "/assets/wedding/chris_medha_webp/w10.webp",
        "/assets/wedding/chris_medha_webp/w11.webp",
        "/assets/wedding/chris_medha_webp/w12.webp",
        "/assets/wedding/chris_medha_webp/w13.webp",
        "/assets/wedding/chris_medha_webp/w14.webp",
        "/assets/wedding/chris_medha_webp/w15.webp",
        "/assets/wedding/chris_medha_webp/w16.webp",
        "/assets/wedding/chris_medha_webp/w17.webp",
        "/assets/wedding/chris_medha_webp/w18.webp",
        "/assets/wedding/chris_medha_webp/w19.webp",
        "/assets/wedding/chris_medha_webp/w20.webp",
        "/assets/wedding/chris_medha_webp/w21.webp",
        "/assets/wedding/chris_medha_webp/w22.webp",
        "/assets/wedding/chris_medha_webp/w23.webp",
        "/assets/wedding/chris_medha_webp/w24.webp",
        "/assets/wedding/chris_medha_webp/w25.webp",
        "/assets/wedding/chris_medha_webp/w26.webp",
        "/assets/wedding/chris_medha_webp/w27.webp",
        "/assets/wedding/chris_medha_webp/w28.webp",
        "/assets/wedding/chris_medha_webp/w29.webp",
        "/assets/wedding/chris_medha_webp/w30.webp",
        // Add your full set
    ];

    return (
        <div className="bg-neutral-950 min-h-screen" style={{ cursor: "none" }}>
            <CustomCursor />
            <Navigation />
            <MasonryGallery
                title="Chris & Medha"
                subtitle="TUSCANY, ITALY — DESTINATION WEDDING"
                images={images}
            />

            <Footer />
        </div>
    );
};

export default ChrisMedhaGallery;
